<template lang="pug">
    div
        Header
        ProgressBar
        .main-wrapper
            router-view
        Footer

</template>

<script>
    import Header from './components/Header';
    import ProgressBar from './components/ProgressBar';
    import EventCategory from './components/pages/reservations/EventCategory';
    import Footer from './components/Footer';

    export default {
        name: 'App',
        components: {
            Header,
            ProgressBar,
            EventCategory,
            Footer
        }
    };
</script>

<style lang="sass">
    @import "assets/css/init-dir.scss"
    @import "assets/css/3-components/_event.sass"
</style>


